var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3489_3953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3489_3953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.75C9.725 9.75 10.3438 9.49375 10.8563 8.98125C11.3688 8.46875 11.625 7.85 11.625 7.125C11.625 6.4 11.3688 5.78125 10.8563 5.26875C10.3438 4.75625 9.725 4.5 9 4.5C8.275 4.5 7.65625 4.75625 7.14375 5.26875C6.63125 5.78125 6.375 6.4 6.375 7.125C6.375 7.85 6.63125 8.46875 7.14375 8.98125C7.65625 9.49375 8.275 9.75 9 9.75ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM3.75 14.25H14.25V13.3875C13.575 12.725 12.7906 12.2031 11.8969 11.8219C11.0031 11.4406 10.0375 11.25 9 11.25C7.9625 11.25 6.99688 11.4406 6.10313 11.8219C5.20938 12.2031 4.425 12.725 3.75 13.3875V14.25Z",
    fill: "#79818A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberBox);
export default __webpack_public_path__ + "static/media/member_box.ebdea7ff641508a96a21b454ab587845.svg";
export { ForwardRef as ReactComponent };